import styled from '@emotion/styled'
import { colors, constants, screenSize } from '../../../tokens'
import {
  CardActions,
  CardContent,
  Card as MuiCard,
  CardMedia as MuiCardMedia,
  Typography,
  css,
} from '@mui/material'
import Section from '../../../components/section'
import { JSX } from 'react'

export const SEventItem = styled(MuiCard)`
  display: 'flex';
  padding: '16px';

  ${screenSize.large(css`
    display: flex;
    align-items: 'center';
    gap: 16px;
    min-height: 180px;
    padding: ${constants.globalBufferSmall};
  `)};
`

export const SCardContent = styled(CardContent)`
  ${screenSize.large(css`
    padding: 0;
    flex-grow: 1;
  `)};
`

export const SDateContainerDesktop = styled(CardContent)`
  display: none;
  ${screenSize.large(css`
    display: flex;
    width: 90px;
    min-width: 90px;
    justify-content: center;
    align-items: center;
    padding: 0;
  `)}
`

export const SDateContainerMobile = styled(CardContent)`
  width: 100%;
  padding-top: 2px;
  padding-bottom: 2px;
  ${screenSize.large(css`
    display: none;
  `)}
`

export const SDateText = styled(Typography)`
  display: flex;
  align-items: center;
  color: ${colors.globalLighterBlue};
  flex-direction: row;
  ${screenSize.large(css`
    flex-direction: column;
    line-height: 1.2;
    width: 56px;
    color: ${colors.globalLighterBlue};
  `)}
`

export const SDateDayDisplay = styled.span`
  font-size: 24px;
  margin: 0 2.5px;
  padding: 0 2px;
  font-weight: 900;
  color: white;

  ${screenSize.large(css`
    margin: 0;
    font-size: 34px;
  `)}
`

export const SCardMedia = styled(MuiCardMedia)`
  height: 205px;
  width: auto;
  position: relative;

  ${screenSize.large(css`
    align-self: 'center';
    aspect-ratio: 280/148;
    height: 148px;
    object-fit: cover;
    border: 1px solid #376191;
  `)}
`

export const SCancelledOverlay = styled.div`
  position: absolute;
  width: 100%;
  height: 100%;
  background-color: rgba(75, 75, 75, 0.75);
  backdrop-filter: blur(2px);
  &::after {
    font-size: 38px;
    color: #ff3333;
    text-shadow: 0 0 8px black;
    letter-spacing: 4px;
    display: flex;
    justify-content: center;
    align-items: center;
    font-weight: bold;
    content: 'cancelled';
    transform: rotate(-15deg) translateY(60px) translateX(-20px);
  }
`

export const SVenueImageContainer = styled.div`
  height: 20px;
  position: relative;
`

export const SItemDetail = styled.div`
  padding: ${constants.globalBufferSmall};
`

export const SItemDetailHeader = styled.div`
  display: block;
  font-size: 20px;
  line-height: 1.2;

  ${screenSize.mobile(css`
    margin: 12px 0 4px !important;
  `)};
  ${screenSize.large(css`
    font-size: 18px;
    margin: 0;
  `)}
`

interface ItemProps {
  key?: string
  children: JSX.Element | JSX.Element[]
}

export const SItem = styled((props: ItemProps) => <Section variant="secondary" {...props} />)`
  // padding-bottom: 1em;
  margin: 0;
  padding: 0;

  ${screenSize.large(css`
    display: flex;
    margin: 0 auto ${constants.globalBufferMedium} !important;
    min-width: ${constants.desktopContentWidth};
    padding: ${constants.globalBufferSmall};
  `)}
`

export const SEventWrapper = styled.div`
  color: white;
`

export const SEventsSection = styled(Section)`
  padding-top: 0;
  margin-top: ${constants.globalBufferXL};
  ${screenSize.large(css`
    padding-top: ${constants.globalBufferXL};
    margin-top: 56px;
  `)}
`

export const STimeAndCommentContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-content: flex-start;
  gap: 16px;
  ${screenSize.large(css`
    flex-direction: row;
  `)}
`

export const SCardActions = styled(CardActions)`
  padding: ${constants.globalBufferSmall};
  padding-top: 4px;
  min-width: 280px;

  ${screenSize.large(css`
    min-width: 248px;
    display: flex;
    align-items: center;
    justify-content: flex-end;
    padding: 0;
  `)}
`

export const SCommentContainer = styled.div`
  padding: 16px;
  display: flex;
  align-content: center;
  justify-content: center;
  background-color: rgba(255, 255, 255, 0.25);
  border-radius: 4px;
  ${screenSize.mobile(css`
    max-width: 'unset';
  `)}
  ${screenSize.large(css`
    flex-grow: 1;
  `)}
`
